export const componentConfigThemeKey = 'threeRowsHeader';

export interface ThreeRowsHeaderThemeProps {
    secondLineTextColor: string;
    secondLineBackgroundColor: string;
    secondLineSelectedIndicatorColor: string;
    thirdLineTextColor: string;
    thirdLineTextColorHover: string;
    thirdLineBackgroundColor: string;
    thirdLineSelectedIndicatorColor: string;
    signInTextColor: string;
    signInBackgroundColor: string;
    signInBorderColor: string;
    subscribeTextColor: string;
    subscribeBackgroundColor: string;
    subscribeBorderColor: string;
}
